import { render, staticRenderFns } from "./EditFormDropdown.vue?vue&type=template&id=3cb1810a"
import script from "./EditFormDropdown.vue?vue&type=script&lang=js"
export * from "./EditFormDropdown.vue?vue&type=script&lang=js"
import style0 from "./EditFormDropdown.vue?vue&type=style&index=0&id=3cb1810a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports